import React, { useState, useEffect } from 'react';
import styles from './viewReferenceCheck.module.scss';
import { Col, Row, Form, Card, Button, Accordion, Tab, Tabs, Container } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { Route, Navigate, NavLink } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import { useParams, useNavigate } from 'react-router-dom';
import Avatar from 'react-avatar';
import CSSLoader from '../../../shared/cssLoader';
import { getReferenceCheckTask } from '../../../../services/util/referenceCheck';
import { submitReferenceCheckTask } from '../../../../services/util/referenceCheck';
import { rejectReferenceCheckTask } from '../../../../services/util/referenceCheck';
import { saveReferenceDetails } from '../../../../services/util/referenceCheck';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';
import CustomNavbar from '../../customNavbar';
import { CustomButton } from '../../../shared/customButton';
import { CustomConfirmationModal } from '../../../shared/customConfirmationModal';
import { CustomConfirmationBox } from '../../../shared/customConfirmationBox';
import { CustomTextArea } from '../../../shared/customTextArea';
import { CustomTextField } from '../../../shared/customTextField';
import { CustomIconButton } from '../../../shared/customIconButton';
import { CustomAlertBox } from '../../../shared/customAlertBox';
import CandidateCvView from '../../common/candidateCvView';
import CandidateCoverLetterView from '../../common/candidateCoverLetterView';
import CandidateAnswersToCustomQuestionsView from '../../common/candidateAnswersToCustomQuestionsView';
import AddCandiateNoteModal from '../../common/addCandidateSpecialNoteModal';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;


const ViewReferenceCheck = (props) => {
    let [numPages, setNumPages] = useState(null);
    let [pageNumber, setPageNumber] = useState(1);
    let [isLoading, setLoading] = useState(false);
    let [isSaveLoading, setSaveLoading] = useState(false);
    const [isSubmit, setSubmit] = useState(false)
    const [isModalOpen, setModalOpen] = useState(false);
    let [accordionIcon, setAccordionIcon] = useState(true);
    let [isURLLoading, setURLLoading] = useState(false);
    const [isRejectModalOpen, setRejectModalOpen] = useState(false);
    let [emptyNameError, setEmptyNameError] = useState(false);
    let [emptyFeedbackError, setEmptyFeedbackError] = useState(false);
    let [candidateReferenceDetails, setCandidateReferenceDetails] = useState([]);
    let [referenceFeedback, setReferenceFeedback] = useState([]);
    let [saveBtnDisable, setSaveBtnDisable] = useState(Array(15).fill(false));
    let [editBtnDisable, setEditBtnDisable] = useState(Array(15).fill(false));
    let [editFeedBackDisable, setEditFeedBackDisable] = useState(Array(15).fill(false));
    let [showCard, setShowCard] = useState(Array(15).fill(true));


    let [state, setState] = useState([]);
    let { id } = useParams();
    let [candidateValues, setCandidateValues] = useState({
        candidate_id: '',
        candidate_first_name: '',
        candidate_last_name: '',
        cv_url: null,
        cover_letter_url: null,
        evaluation_criteria: '',
        pipeline_stage_name: '',
        cv_review_session_id: null,
        custom_question_answers: []
    });
    const [cvObject, setCVObject] = useState(null)
    let [specialNoteModalOpen, setSpecialNoteModalOpen] = useState(false);
    let [candidateReferenceState, setCandidateReferenceState] = useState('');

    let history = useNavigate();
    const options = {
        cMapUrl: 'cmaps/',
        cMapPacked: true,
    };
    const breadcrumb = [
        {
            pathaddress: '/app/company/reference-checks',
            pathname: 'Reference Checks',
            isActive: false,
            key: 2 + 'Reference Check'
        },
        {
            pathaddress: '',
            pathname: candidateValues.candidate_first_name + ' ' + candidateValues.candidate_last_name,
            isActive: true,
            key: 3 + 'Reference Check'
        },
    ]

    let main_props = {
        permissions: props.permissions,
        role: props.role,
        toggleInterviewView: props.toggleInterviewView
    }

    //candidate submit reference schema
    const candidateSubmitFormSchema = yup.object({
        feedback: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required("Required"),
    });

    //company user submit reference schema
    const companyUserSubmitFormSchema = yup.object({
        referenceName: yup.string().required('Name is required'),
        referenceEmail: yup.string().email('Invalid email').required('Email is required'),
        referencePosition: yup.string().required('Position is required'),
        referenceCompany: yup.string().required('Company / Organization is required'),
    });

    ///////////
    //company user submit reference section
    let [referenceDetails, setReferenceDetails] = useState([]);
    let [referenceCount, setReferenceCount] = useState(0);
    let [errorMessage, setErrorMessage] = useState('');

    //add reference array
    const addReferenceArray = (values, { resetForm }) => {
        let referenceArray = [...referenceDetails];
        referenceArray.push({
            referenceName: values.referenceName,
            referenceEmail: values.referenceEmail,
            referenceMobileNum: values.referenceMobileNum,
            referencePosition: values.referencePosition,
            referenceCompany: values.referenceCompany
        });

        setReferenceDetails(referenceArray);
        setReferenceCount(referenceArray.length);
        resetForm({ referenceName: '' });
        resetForm({ referenceEmail: '' });
        resetForm({ referenceMobileNum: '' });
        resetForm({ referencePosition: '' });
        resetForm({ referenceCompany: '' });
    }

    const deleteReference = (index) => {
        // Create a new array based on current state:
        const newArray = [...referenceDetails];
        newArray.splice(index, 1);
        // Update the state with the new array
        setReferenceDetails(newArray);
        setReferenceCount(newArray.length);
    }
    ///////////



    function nextPage() {
        if (pageNumber !== numPages) {
            setPageNumber(prevState => prevState + 1);
        }
    }

    const saveFeedback = async (values, index, state) => {
        setSaveLoading(true);
        //state 1 => user add new reference
        if (Object.keys(values).length !== 0) {
            const updatedFeedback = [...referenceFeedback];
            updatedFeedback[index] = values;
            setReferenceFeedback(updatedFeedback);

            const updateSaveBtn = [...saveBtnDisable];
            updateSaveBtn[index] = true;
            setSaveBtnDisable(updateSaveBtn);

            const updateFeedbackForm = [...editBtnDisable];
            updateFeedbackForm[index] = true;
            setEditBtnDisable(updateFeedbackForm);

            const updateShowCard = [...showCard];
            updateShowCard[index] = false;
            setShowCard(updateShowCard);

            try {
                setLoading(true);
                let respond = await saveReferenceDetails(id, referenceDetails, values, index, state);
                if (respond.success !== true) {
                    setErrorMessage('Failed to save reference details.');
                }

                // Call getReferenceCheckDetails after successful save
                await getReferenceCheckDetails();
                setEmptyFeedbackError(false);
                setErrorMessage('');
                setSaveLoading(false);
                setLoading(false);
            } catch (error) {
                setErrorMessage('Failed to save reference details.');
                setSaveLoading(false);
            }
        } else {
            setEmptyFeedbackError(true);
            setSaveLoading(false);
        }
    }
    const editAndsaveFeedback = async (values, index, state) => {
        setSaveLoading(true);
        //state 1 => user add new reference
        if (Object.keys(values).length !== 0) {
            const updatedFeedback = [...referenceFeedback];
            updatedFeedback[index] = values;
            setReferenceFeedback(updatedFeedback);

            const updateSaveBtn = [...saveBtnDisable];
            updateSaveBtn[index] = true;
            setSaveBtnDisable(updateSaveBtn);

            const updateFeedbackForm = [...editBtnDisable];
            updateFeedbackForm[index] = true;
            setEditBtnDisable(updateFeedbackForm);

            const updateShowCard = [...showCard];
            updateShowCard[index] = true;
            setShowCard(updateShowCard);

            try {
                setLoading(true);
                let respond = await saveReferenceDetails(id, referenceDetails, values, index, state);
                if (respond.success !== true) {
                    setErrorMessage('Failed to save reference details.');
                }

                // Call getReferenceCheckDetails after successful save
                await getReferenceCheckDetails();
                setEmptyFeedbackError(false);
                setErrorMessage('');
                setSaveLoading(false);
                setLoading(false);
            } catch (error) {
                setErrorMessage('Failed to save reference details.');
                setSaveLoading(false);
            }
        } else {
            setEmptyFeedbackError(true);
            setSaveLoading(false);
        }
    }



    const editFeedback = (values, index) => {

        // enable the save button
        // Create a copy of the saveBtnDisable array
        const updateSaveBtn = [...saveBtnDisable];
        // Update the value at the specified index
        updateSaveBtn[index] = false;
        setSaveBtnDisable(updateSaveBtn);

        const updateShowCard = [...showCard];
            updateShowCard[index] = false;
            setShowCard(updateShowCard);

        // Create a new array based on current state:
        const newArray = [...referenceFeedback];
        newArray.splice(index, 1);
        // Update the state with the new array
        setReferenceFeedback(newArray);

        const updateFeedbackForm = [...editFeedBackDisable];

        // Update the value at the specified index
        updateFeedbackForm[index] = false;
        setEditFeedBackDisable(updateFeedbackForm);

        const updateEditBtn = [...editBtnDisable];
        updateEditBtn[index] = true;
        setEditBtnDisable(updateEditBtn);

    }


    function prevPage() {
        if (pageNumber !== 1) {
            setPageNumber(prevState => prevState - 1);
        }
    }

    //on pdf load success
    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        setNumPages(nextNumPages);
    }

    function checkValidationAndOpenModal() {

        let countSavebtnEnable = 0;
        let countReferenceFeedback = 0;

        //check if all feedback is saved
        if (candidateReferenceDetails.length > 0) {

            for (let i = 0; i < candidateReferenceDetails.length; i++) {
                if (saveBtnDisable[i]) {
                    countSavebtnEnable++;
                }
                if (candidateReferenceDetails[i].feedback) {
                    countReferenceFeedback++;
                }

            }
            //check if all reference feedback is saved
            if ((candidateReferenceDetails.length == countSavebtnEnable) || candidateReferenceDetails.length === countReferenceFeedback) {
                setModalOpen(true);
            }
            else {
                setErrorMessage('Please save all feedback before submitting');
                setEmptyFeedbackError(true);
            }
        } else {
            setErrorMessage('Please add reference before submitting');
            setEmptyFeedbackError(true);

        }


    }


    //Reject candidate
    function onClickReject() {

        let countSavebtnEnable = 0;
        let countReferenceFeedback = 0;

        //check if all feedback is saved
        if (candidateReferenceDetails.length > 0) {

            for (let i = 0; i < candidateReferenceDetails.length; i++) {
                if (saveBtnDisable[i]) {
                    countSavebtnEnable++;
                }
                if (candidateReferenceDetails[i].feedback) {
                    countReferenceFeedback++;
                }

            }

            if ((candidateReferenceDetails.length == countSavebtnEnable) || candidateReferenceDetails.length === countReferenceFeedback) {
                setRejectModalOpen(true);
            }
            else {
                setErrorMessage('Please save all feedback before submitting');
                setEmptyFeedbackError(true);
            }
        } else {
            setErrorMessage('Please add reference before submitting');
            setEmptyFeedbackError(true);

        }
    }




    //submit values function
    async function submitValues() {

        setSubmit(true)
        let respond = await submitReferenceCheckTask(id)
        if (respond.success === true) {
            props.GetTaskValues();
            history(`/company/reference-checks/group?step_id=${candidateValues.step_id}`);
            setSubmit(false);
        } else {
            setSubmit(false);
        }

    }

    //submit reject values function
    async function submitRejectValues(values) {

        setSubmit(true)
        let respond = await rejectReferenceCheckTask(id, values.reason)
        if (respond.success === true) {
            props.GetTaskValues();
            history(`/company/reference-checks/group?step_id=${candidateValues.step_id}`);
            setSubmit(false);
        } else {
            setSubmit(false);
        }

    }

    //load user values
    const getReferenceCheckDetails = async () => {
        setLoading(true)
        let respond = await getReferenceCheckTask(id)
        if (respond.success === true) {
            await setCandidateValues(respond.data)
            await setCVObject(respond.data.cv_url)
            setCandidateReferenceDetails(respond.data.candidate_submitted_references);
            setCandidateReferenceState(respond.data.reference_state);
            setLoading(false)
        } else {
            setLoading(false)
            history('/company/reference-checks')
        }
    }

    //open and close note modal
    const openSpecialNoteModal = () => {
        setSpecialNoteModalOpen(true);
    }

    const closeSpecialNoteModal = () => {
        setSpecialNoteModalOpen(false);
    }


    useEffect(() => {
        getReferenceCheckDetails();
    }, []);


    useEffect(() => {
        let pageHit = '/company/reference-checks';
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: pageHit});
    }, [])

    function viewCandidate(val) {
        let path = `/app/company/candidate`;
        let search = 'cid=' + val;

        const url = `${path}?${search}`;
        window.open(url);
    }


    return (
        <div>
            <Helmet>
                <title>Reference Checks | HireTrace</title>
            </Helmet>
            {isLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>

                    {/* submit result alert confirmation start */}
                    <CustomConfirmationModal
                        show={isModalOpen}
                        confirmationType='success'
                        cancelIconclick={() => setModalOpen(false)}
                        onSecondaryBtnClick={() => setModalOpen(false)}
                        onPrimaryBtnClick={submitValues}
                        isSecondaryBtnDisabled={isSubmit === true ? true : false}
                        isPrimaryBtnDisabled={isSubmit === true ? true : false}
                        primaryBtnBackSideIcon={isSubmit === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage="Your feedback cannot change later."
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="successBtn"
                        primaryBtnLabel="Yes, Submit!"
                    />
                    {/* submit result alert confirmation end */}

                    {/* submit result alert confirmation start */}
                    {
                        <CustomConfirmationBox
                            show={isRejectModalOpen}
                            cancelIconclick={() => setRejectModalOpen(false)}
                            onSecondaryBtnClick={() => setRejectModalOpen(false)}
                            onFormSubmit={submitRejectValues}
                            isSecondaryBtnDisabled={isSubmit === true ? true : false}
                            isPrimaryBtnDisabled={isSubmit === true ? true : false}
                            primaryBtnBackSideIcon={isSubmit === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                            preCheckedCondition={true}
                            topic="Are you sure?"
                            message={`You are trying to reject the candidate.`}
                            secondaryBtnName="backBtn"
                            secondaryBtnType="button"
                            secondaryBtnCssType="defaultBtn"
                            secondaryBtnLabel="Cancel"
                            primaryBtnName="submitRejectBtn"
                            primaryBtnType="submit"
                            primaryBtnCssType="dangerBtn"
                            primaryBtnLabel="Yes, reject candidate"
                        />}
                    {/* submit result alert confirmation end */}

                    {/* open add note modal */}
                    {specialNoteModalOpen &&
                        <AddCandiateNoteModal showModal={specialNoteModalOpen} handleClose={() => setSpecialNoteModalOpen(false)} candidateID={candidateValues.candidate_id} />
                    }
                    {/* close add note modal */}

                    {/* Alert Box End */}
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                    </div>

                    {/* <Row className={styles.bodyRow}>
                        <Col md={7} lg={8} xl={9} className={styles.leftSideRow}> */}

                    {/* candidate review details */}
                    <Row>
                        <Col>
                            <div className={styles.reviewDetails}>
                                <Row>
                                    <Col md={1} lg={1} xl={1} className={styles.candidatePhoto}>
                                        <Avatar src={candidateValues.candidate_photo_url} name={candidateValues.candidate_first_name + ' ' + candidateValues.candidate_last_name} size="90" round={false} />
                                    </Col>
                                    <Col md={11} lg={11} xl={11} className={styles.candidateDetails}>
                                        <Row>
                                            <Col sm={5}>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Name : </span><span className={styles.reviewDetailsValue}>{candidateValues.candidate_first_name + ' ' + candidateValues.candidate_last_name}</span> <i onClick={() => viewCandidate(candidateValues.candidate_id)} class="fas fa-external-link-alt ml-1S" id={styles.openInNewtabIcon}></i> </p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Email : </span><span className={styles.reviewDetailsValue}>{candidateValues.candidate_email}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Mobile : </span><span className={styles.reviewDetailsValue}>{`(${candidateValues.candidate_mobile_country_code}) ${candidateValues.candidate_mobile_number}`}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Passing Threshold : </span><span className={styles.reviewDetailsValue}>Pass | Fail</span></p>
                                            </Col>
                                            <Col sm={5}>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Pipeline : </span><span className={styles.reviewDetailsValue}>{candidateValues.pipeline_name}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Position : </span><span className={styles.reviewDetailsValue}>{candidateValues.hiring_position}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Stage Name : </span><span className={styles.reviewDetailsValue}>{candidateValues.pipeline_stage_name}</span></p>

                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Review Criteria : </span><span className={styles.reviewDetailsValue}>{candidateValues.evaluation_criteria}</span></p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>

                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <div className={styles.reviewAreaBox}>
                                <Col>
                                    <Row >
                                        <Col md={7} lg={8} xl={9} className={styles.reviewAreaLeft}>


                                            {/* reference , view cv , cover letter and Custom Questions  */}
                                            <Tabs
                                                defaultActiveKey="referenceCheck"
                                                id="controlled-tab-example"
                                                className={styles.tabGroup}
                                            >
                                                <Tab eventKey="referenceCheck" title="Reference Check" tabClassName={styles.tabItem} >
                                                    <div>
                                                        {(candidateReferenceState == 0 || candidateReferenceState == 3  || candidateReferenceState == 6 || candidateReferenceState == 7) ? (

                                                            <div className="mt-3">
                                                                {/*user reference add side*/}
                                                                <Card className={styles.ReferenceMainCard}>

                                                                    <Card.Body className={styles.cvViewBody}>


                                                                        <div className={styles.userAddReferenceForm}>
                                                                            <Formik
                                                                                validationSchema={companyUserSubmitFormSchema}
                                                                                onSubmit={(values, resetForm) => {
                                                                                    addReferenceArray(values, resetForm);
                                                                                }}
                                                                                initialValues={{}}
                                                                            >
                                                                                {({
                                                                                    errors,
                                                                                    handleChange,
                                                                                    handleSubmit,
                                                                                    setFieldValue,
                                                                                    submitCount,
                                                                                    resetForm,
                                                                                    values
                                                                                }) => (
                                                                                    <Form noValidate onSubmit={handleSubmit}>

                                                                                        <CustomTextField
                                                                                            label="Name"
                                                                                            classLabel="defaultLabel"
                                                                                            controlId="referenceName"
                                                                                            type="text"
                                                                                            name="referenceName"
                                                                                            classType="defaultTextBox"
                                                                                            handleOnChange={handleChange}
                                                                                            errorMessage={errors.referenceName}
                                                                                            placeholder="Enter reference person name"
                                                                                            value={values.referenceName || ''}
                                                                                            isInvalid={submitCount > 0 && !!errors.referenceName}
                                                                                        />

                                                                                        <CustomTextField
                                                                                            label="Email"
                                                                                            classLabel="defaultLabel"
                                                                                            controlId="referenceEmail"
                                                                                            type="email"
                                                                                            name="referenceEmail"
                                                                                            classType="defaultTextBox"
                                                                                            handleOnChange={handleChange}
                                                                                            errorMessage={errors.referenceEmail}
                                                                                            placeholder="Enter reference person email"
                                                                                            value={values.referenceEmail || ''}
                                                                                            isInvalid={submitCount > 0 && !!errors.referenceEmail}
                                                                                        />

                                                                                        <CustomTextField
                                                                                            label="Mobile Number"
                                                                                            classLabel="defaultLabel"
                                                                                            controlId="referenceMobileNum"
                                                                                            type="text"
                                                                                            name="referenceMobileNum"
                                                                                            classType="defaultTextBox"
                                                                                            handleOnChange={handleChange}
                                                                                            errorMessage={errors.referenceMobileNum}
                                                                                            value={values.referenceMobileNum || ''}
                                                                                            placeholder="Enter reference person number"
                                                                                            isInvalid={submitCount > 0 && !!errors.referenceMobileNum}
                                                                                        />


                                                                                        <Row>
                                                                                            <Col>
                                                                                                <CustomTextField
                                                                                                    label="Position"
                                                                                                    classLabel="defaultLabel"
                                                                                                    controlId="referencePosition"
                                                                                                    type="text"
                                                                                                    name="referencePosition"
                                                                                                    classType="defaultTextBox"
                                                                                                    placeholder="Enter position"
                                                                                                    value={values.referencePosition || ''}
                                                                                                    handleOnChange={handleChange}
                                                                                                    errorMessage={errors.referencePosition}
                                                                                                    isInvalid={submitCount > 0 && !!errors.referencePosition}
                                                                                                />
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <CustomTextField
                                                                                                    label="Company / Organization"
                                                                                                    classLabel="defaultLabel"
                                                                                                    controlId="referenceCompany"
                                                                                                    type="text"
                                                                                                    name="referenceCompany"
                                                                                                    classType="defaultTextBox"
                                                                                                    placeholder="Enter company"
                                                                                                    handleOnChange={handleChange}
                                                                                                    value={values.referenceCompany || ''}
                                                                                                    errorMessage={errors.referenceCompany}
                                                                                                    isInvalid={submitCount > 0 && !!errors.referenceCompany}
                                                                                                />
                                                                                            </Col>

                                                                                        </Row>

                                                                                        <div className='mt-4 mb-4'>
                                                                                            <CustomButton
                                                                                                buttonType="submit"
                                                                                                type="borderSecondaryBtn"
                                                                                                label="Add Reference"

                                                                                            />
                                                                                        </div>

                                                                                    </Form>
                                                                                )}
                                                                            </Formik>
                                                                            <Row className='mt-2 text-end'>
                                                                                <div>
                                                                                    <p>Reference Count Min({candidateReferenceDetails.length}/{candidateValues.min_no_of_references_required})</p>
                                                                                </div>
                                                                                {errorMessage && (
                                                                                    <p className={styles.errorMessageSubmit}>{errorMessage}</p>
                                                                                )}
                                                                            </Row>


                                                                        </div>
                                                                    </Card.Body>
                                                                </Card>
                                                                {candidateReferenceDetails.length || referenceDetails.length ? (
                                                                    <div className="mt-3">
                                                                        <Card className={styles.ReferenceMainCard}>

                                                                            <Card.Body className={styles.cvViewBody}>
                                                                                <>
                                                                                    {referenceDetails.length > 0 && referenceDetails?.map((reference, index) => (
                                                                                        <div key={index}>
                                                                                            {!saveBtnDisable[index] && showCard[index] &&(
                                                                                                <Card className={styles.ReferenceSecCard}>
                                                                                                    <Card.Header className={styles.cardHeaderWithDelete}>
                                                                                                        <div className={styles.headerDetails}>
                                                                                                            <p className={styles.accordianHeaderTopic}>Reference &nbsp;&nbsp;</p>
                                                                                                            <div>
                                                                                                                {!saveBtnDisable[index] && (
                                                                                                                    <div className={styles.deleteButton}>
                                                                                                                        <CustomIconButton
                                                                                                                            type="defaultBtn"
                                                                                                                            icon={
                                                                                                                                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                                    <path d="M14.707 4.7958V4.03664C14.707 2.97371 14.707 2.44225 14.4772 2.03627C14.275 1.67916 13.9524 1.38882 13.5556 1.20686C13.1045 1 12.514 1 11.333 1H9.64598C8.46495 1 7.87444 1 7.42335 1.20686C7.02656 1.38882 6.70396 1.67916 6.50178 2.03627C6.27194 2.44225 6.27194 2.97371 6.27194 4.03664V4.7958M8.38071 10.015V14.7598M12.5983 10.015V14.7598M1 4.7958H19.979M17.8702 4.7958V15.424C17.8702 17.0184 17.8702 17.8156 17.5254 18.4246C17.2222 18.9602 16.7383 19.3958 16.1431 19.6687C15.4664 19.979 14.5807 19.979 12.8091 19.979H8.16984C6.3983 19.979 5.51253 19.979 4.83589 19.6687C4.24071 19.3958 3.7568 18.9602 3.45354 18.4246C3.10878 17.8156 3.10878 17.0184 3.10878 15.424V4.7958" stroke="white" stroke-width="1.42342" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                                                </svg>
                                                                                                                            }
                                                                                                                            handleClick={() => deleteReference(index)}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                )}

                                                                                                            </div>
                                                                                                        </div>

                                                                                                    </Card.Header>
                                                                                                    <Card.Body className={styles.referenceBody}>
                                                                                                        <Row>
                                                                                                            {/*Left Side*/}
                                                                                                            <Col sm={5} className='ms-3'>
                                                                                                                <div className={styles.textFormat}>
                                                                                                                    <Row>
                                                                                                                        <p><span className={styles.referenceDetailsText}>Name : </span>{reference.referenceName}</p>
                                                                                                                    </Row>
                                                                                                                    <Row>
                                                                                                                        <p><span className={styles.referenceDetailsText}>Email : </span>{reference.referenceEmail}</p>
                                                                                                                    </Row>
                                                                                                                    <Row>
                                                                                                                        <p><span className={styles.referenceDetailsText}>Mobile Number :</span> {reference.referenceMobileNum}</p>
                                                                                                                    </Row>
                                                                                                                    <Row>
                                                                                                                        <p><span className={styles.referenceDetailsText}>Position : </span>{reference.referencePosition}</p>
                                                                                                                    </Row>
                                                                                                                    <Row>
                                                                                                                        <p><span className={styles.referenceDetailsText}>Company / Organization : </span>{reference.referenceCompany}</p>
                                                                                                                    </Row>
                                                                                                                </div>
                                                                                                            </Col>
                                                                                                            {/*Right Side*/}
                                                                                                            <Col sm={6}>
                                                                                                                <Formik
                                                                                                                    validationSchema={candidateSubmitFormSchema}
                                                                                                                    onSubmit={(values, resetForm) => { }}
                                                                                                                    initialValues={{ feedback: reference.feedback ? reference.feedback : '' }}>
                                                                                                                    {({
                                                                                                                        values,
                                                                                                                        errors,
                                                                                                                        setFieldValue,
                                                                                                                        handleChange,
                                                                                                                        handleSubmit,
                                                                                                                        resetForm
                                                                                                                    }) => (
                                                                                                                        <div>
                                                                                                                            <Form noValidate onSubmit={handleSubmit}>
                                                                                                                                <CustomTextArea
                                                                                                                                    id="feedback"
                                                                                                                                    name="feedback"
                                                                                                                                    label="Reference feedback"
                                                                                                                                    values={values.feedback}
                                                                                                                                    handleChange={(e) => { setFieldValue('feedback', e.target.value); }}
                                                                                                                                    placeholder="Write your feedback here"
                                                                                                                                    isInvalid={errors.feedback || emptyFeedbackError}
                                                                                                                                    className={styles.textareaBox}
                                                                                                                                    rows={3}
                                                                                                                                    disabled={(referenceDetails.feedback && !saveBtnDisable[index] && !editBtnDisable[index]) || saveBtnDisable[index] == true ? true : false}
                                                                                                                                />
                                                                                                                                <p className={styles.errorMessageComments}>{errors.feedback}</p>
                                                                                                                                <div>
                                                                                                                                    <Row>
                                                                                                                                        <Col className={styles.newReferenceSaveBtn}>
                                                                                                                                            <CustomButton
                                                                                                                                                id="add_comment"
                                                                                                                                                buttonType="primarySmallBtn"
                                                                                                                                                label="Save Feedback"
                                                                                                                                                type="secondaryBtn"
                                                                                                                                                handleClick={() => saveFeedback(values, index, 1)}
                                                                                                                                                disabled={(referenceDetails.feedback && !saveBtnDisable[index] && !editBtnDisable[index]) || saveBtnDisable[index] || !values.feedback == true ? true : false}
                                                                                                                                            />
                                                                                                                                        </Col>                                                                  
                                                                                                                                    </Row>
                                                                                                                                </div>
                                                                                                                            </Form>
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                </Formik>
                                                                                                            </Col>
                                                                                                        </Row>
                                                                                                    </Card.Body>
                                                                                                </Card>
                                                                                            )}
                                                                                        </div>
                                                                                    ))}
                                                                                    {candidateReferenceDetails?.map((referenceDetails, index) => (
                                                                                        <Card className={styles.ReferenceSecCard}>
                                                                                            <Card.Header className={styles.cardHeader}>
                                                                                                <div className={styles.headerDetails}>
                                                                                                    <p className={styles.accordianHeaderTopic}>Reference {index + 1}&nbsp;&nbsp;</p>
                                                                                                </div>
                                                                                            </Card.Header>
                                                                                            <Card.Body className={styles.referenceBody}>
                                                                                                <Row>
                                                                                                    {/*Left Side*/}
                                                                                                    <Col sm={5} className='ms-3'>
                                                                                                        <div className={styles.textFormat}>
                                                                                                            <Row>
                                                                                                                <p><span className={styles.referenceDetailsText}>Name : </span>{referenceDetails.reference_name}</p>
                                                                                                            </Row>
                                                                                                            <Row>
                                                                                                                <p><span className={styles.referenceDetailsText}>Email : </span>{referenceDetails.reference_email}</p>
                                                                                                            </Row>
                                                                                                            <Row>
                                                                                                                <p><span className={styles.referenceDetailsText}>Mobile Number :</span> {referenceDetails.mobile_num}</p>
                                                                                                            </Row>
                                                                                                            <Row>
                                                                                                                <p><span className={styles.referenceDetailsText}>Position : </span>{referenceDetails.position}</p>
                                                                                                            </Row>
                                                                                                            <Row>
                                                                                                                <p><span className={styles.referenceDetailsText}>Company / Organization : </span>{referenceDetails.company}</p>
                                                                                                            </Row>
                                                                                                        </div>
                                                                                                    </Col>
                                                                                                    {/*Right Side*/}
                                                                                                    <Col sm={6}>



                                                                                                        <Formik
                                                                                                            validationSchema={candidateSubmitFormSchema}
                                                                                                            onSubmit={(values, resetForm) => { }}
                                                                                                            initialValues={{ feedback: referenceDetails.feedback ? referenceDetails.feedback : '' }}>

                                                                                                            {({
                                                                                                                values,
                                                                                                                errors,
                                                                                                                setFieldValue,
                                                                                                                handleChange,
                                                                                                                handleSubmit,
                                                                                                                resetForm
                                                                                                            }) => (
                                                                                                                <div>
                                                                                                                    <Form noValidate onSubmit={handleSubmit}>
                                                                                                                        <CustomTextArea
                                                                                                                            id="feedback"
                                                                                                                            name="feedback"
                                                                                                                            label="Reference feedback"
                                                                                                                            values={values.feedback}
                                                                                                                            handleChange={(e) => { setFieldValue('feedback', e.target.value); }}
                                                                                                                            placeholder="Write your feedback here"
                                                                                                                            isInvalid={errors.feedback || emptyFeedbackError}
                                                                                                                            className={styles.textareaBox}
                                                                                                                            rows={3}
                                                                                                                            disabled={(referenceDetails.feedback && !saveBtnDisable[index] && !editBtnDisable[index]) || saveBtnDisable[index] == true ? true : false}
                                                                                                                        />
                                                                                                                        <p className={styles.errorMessageComments}>{errors.feedback}</p>


                                                                                                                        <div>
                                                                                                                            <Row>
                                                                                                                                <Col className='ms-5 pt-1'>
                                                                                                                                    <CustomButton
                                                                                                                                        id="add_comment"
                                                                                                                                        buttonType="primarySmallBtn"
                                                                                                                                        label="Save Feedback"
                                                                                                                                        type="secondaryBtn"
                                                                                                                                        handleClick={() => saveFeedback(values, index)}
                                                                                                                                        disabled={(referenceDetails.feedback && !saveBtnDisable[index] && !editBtnDisable[index]) || saveBtnDisable[index] || !values.feedback == true ? true : false}
                                                                                                                                    />
                                                                                                                                </Col>
                                                                                                                                <Col className='pt-1'>
                                                                                                                                    <CustomButton
                                                                                                                                        id="add_comment"
                                                                                                                                        buttonType="primarySmallBtn"
                                                                                                                                        label="Edit Feedback"
                                                                                                                                        type="secondaryBtn"
                                                                                                                                        disabled={(!referenceDetails.feedback && !saveBtnDisable[index] && !editBtnDisable[index]) || editFeedBackDisable[index] == true ? true : false}
                                                                                                                                        handleClick={() => editFeedback(values, index)}

                                                                                                                                    />
                                                                                                                                </Col>
                                                                                                                            </Row>
                                                                                                                        </div>
                                                                                                                    </Form>
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </Formik>

                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </Card.Body>

                                                                                        </Card>
                                                                                    ))}
                                                                                </>

                                                                            </Card.Body>
                                                                        </Card>

                                                                    </div>
                                                                ) : ('')}

                                                            </div>

                                                        )
                                                            :
                                                            (

                                                                <div>
                                                                    {/*candidate refernce add side*/}
                                                                    <div className="mt-3">
                                                                        <Card className={styles.ReferenceMainCard}>

                                                                            <Card.Body className={styles.cvViewBody}>
                                                                                <>
                                                                                    {candidateReferenceDetails?.map((referenceDetails, index) => (
                                                                                        <Card className={styles.ReferenceSecCard}>
                                                                                            <Card.Header className={styles.cardHeader}>
                                                                                                <div className={styles.headerDetails}>
                                                                                                    <p className={styles.accordianHeaderTopic}>Reference {index + 1}&nbsp;&nbsp;</p>
                                                                                                </div>
                                                                                            </Card.Header>
                                                                                            <Card.Body className={styles.referenceBody}>
                                                                                                <Row>
                                                                                                    {/*Left Side*/}
                                                                                                    <Col sm={5} className='ms-3'>
                                                                                                        <div className={styles.textFormat}>
                                                                                                            <Row>
                                                                                                                <p><span className={styles.referenceDetailsText}>Name : </span>{referenceDetails.reference_name}</p>
                                                                                                            </Row>
                                                                                                            <Row>
                                                                                                                <p><span className={styles.referenceDetailsText}>Email : </span>{referenceDetails.reference_email}</p>
                                                                                                            </Row>
                                                                                                            <Row>
                                                                                                                <p><span className={styles.referenceDetailsText}>Mobile Number :</span> {referenceDetails.mobile_num}</p>
                                                                                                            </Row>
                                                                                                            <Row>
                                                                                                                <p><span className={styles.referenceDetailsText}>Position : </span>{referenceDetails.position}</p>
                                                                                                            </Row>
                                                                                                            <Row>
                                                                                                                <p><span className={styles.referenceDetailsText}>Company / Organization : </span>{referenceDetails.company}</p>
                                                                                                            </Row>
                                                                                                        </div>
                                                                                                    </Col>
                                                                                                    {/*Right Side*/}
                                                                                                    <Col sm={6}>



                                                                                                        <Formik
                                                                                                            validationSchema={candidateSubmitFormSchema}
                                                                                                            onSubmit={(values, resetForm) => { }}
                                                                                                            initialValues={{ feedback: referenceDetails.feedback ? referenceDetails.feedback : '' }}>

                                                                                                            {({
                                                                                                                values,
                                                                                                                errors,
                                                                                                                setFieldValue,
                                                                                                                handleChange,
                                                                                                                handleSubmit,
                                                                                                                resetForm
                                                                                                            }) => (
                                                                                                                <div>
                                                                                                                    <Form noValidate onSubmit={handleSubmit}>
                                                                                                                        <CustomTextArea
                                                                                                                            id="feedback"
                                                                                                                            name="feedback"
                                                                                                                            label="Reference feedback"
                                                                                                                            values={values.feedback}
                                                                                                                            handleChange={(e) => { setFieldValue('feedback', e.target.value); }}
                                                                                                                            placeholder="Write your feedback here"
                                                                                                                            isInvalid={errors.feedback || emptyFeedbackError}
                                                                                                                            className={styles.textareaBox}
                                                                                                                            rows={3}
                                                                                                                            disabled={(referenceDetails.feedback && !saveBtnDisable[index] && !editBtnDisable[index]) || saveBtnDisable[index] == true ? true : false}
                                                                                                                        />
                                                                                                                        <p className={styles.errorMessageComments}>{errors.feedback}</p>


                                                                                                                        <div>
                                                                                                                            <Row>
                                                                                                                                <Col className='ms-5 pt-1'>
                                                                                                                                    <CustomButton
                                                                                                                                        id="add_comment"
                                                                                                                                        buttonType="primarySmallBtn"
                                                                                                                                        label="Save Feedback"
                                                                                                                                        type="secondaryBtn"
                                                                                                                                        handleClick={() => editAndsaveFeedback(values, index)}
                                                                                                                                        disabled={(referenceDetails.feedback && !saveBtnDisable[index] && !editBtnDisable[index]) || saveBtnDisable[index] || !values.feedback == true ? true : false}
                                                                                                                                    />
                                                                                                                                </Col>
                                                                                                                                <Col className='pt-1'>
                                                                                                                                    <CustomButton
                                                                                                                                        id="add_comment"
                                                                                                                                        buttonType="primarySmallBtn"
                                                                                                                                        label="Edit Feedback"
                                                                                                                                        type="secondaryBtn"
                                                                                                                                        disabled={(!referenceDetails.feedback && !saveBtnDisable[index] && !editBtnDisable[index]) || editFeedBackDisable[index] == true ? true : false}
                                                                                                                                        handleClick={() => editFeedback(values, index)}

                                                                                                                                    />
                                                                                                                                </Col>
                                                                                                                            </Row>
                                                                                                                        </div>
                                                                                                                    </Form>
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </Formik>

                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </Card.Body>

                                                                                        </Card>
                                                                                    ))}
                                                                                </>

                                                                            </Card.Body>
                                                                        </Card>
                                                                    </div>

                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </Tab>
                                                <Tab eventKey="cv" title="CV" tabClassName={styles.tabItem} >

                                                    <CandidateCvView candidateValues={candidateValues} stepId={id} cvURL={candidateValues.cv_url} candidateID={candidateValues.candidate_id}
                                                    />
                                                </Tab>
                                                {candidateValues.cover_letter_url ? <Tab eventKey="CoverLetter" title="Cover Letter" tabClassName={styles.tabItem}>
                                                    <CandidateCoverLetterView candidateValues={candidateValues} stepId={id} coverLetterURL={candidateValues.cover_letter_url} candidateID={candidateValues.candidate_id} />
                                                </Tab> : null}
                                                {candidateValues.custom_question_answers && candidateValues.custom_question_answers.length > 0 ?
                                                    <Tab eventKey="customQuestions" title="Custom Questions" tabClassName={styles.tabItem}>
                                                        <CandidateAnswersToCustomQuestionsView candidateValues={candidateValues} />
                                                    </Tab> : null}
                                            </Tabs>
                                        </Col>
                                        <Col className={styles.reviewSubmissionColumn} md={5} lg={4} xl={3}>

                                            <Card className={styles.reviewSubmissionCard}>
                                                <Card.Header className={styles.reviewSubmissionCardHeader}>
                                                    <div className={styles.reviewSubmissionCardheaderDetails}>
                                                        <p className={styles.reviewSubmissionCardHeaderTopic}>Reference Check</p>
                                                    </div>
                                                </Card.Header>
                                                <Card.Body>
                                                    <div className={styles.addNoteDiv}>
                                                        <p className={styles.noteValue} onClick={() => openSpecialNoteModal()}>Add special note</p>
                                                    </div>
                                                    <div>
                                                        <p className={styles.reviewFeedbackLabel}>Feedback</p>
                                                    </div>
                                                    {errorMessage && (
                                                        <div>
                                                            <p className={styles.errorMessageSubmit}>{errorMessage}</p>
                                                        </div>
                                                    )}
                                                    <div>
                                                        <CustomButton
                                                            buttonType="submit"
                                                            type="primaryBtn"
                                                            label="Submit and Pass to Next Step"
                                                            disabled={isSubmit === true ? true : false}
                                                            handleClick={checkValidationAndOpenModal}
                                                        />
                                                    </div>

                                                    <div style={{ marginTop: '10px' }}>
                                                        <CustomButton
                                                            buttonType="submit"
                                                            type="dangerBtn"
                                                            label="Submit and Reject"
                                                            disabled={isSubmit === true ? true : false}
                                                            handleClick={onClickReject}
                                                        />
                                                    </div>

                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        </Col>
                    </Row>

                </div>)
            }
        </div >
    )
}

export default ViewReferenceCheck;
